export default "__VITE_ASSET__6eaa298b__"